import React from "react";
import "./App.scss";
import "./Layout.scss";

import NavBar from "./components/NavBar/";

import DeviceBar from "./components/DeviceBar/DeviceBar";
import WidgetBar from "./components/WidgetBar/WidgetBar";

import Modal from "./components/Modal";
import DragLayer from "./components/DragLayer/DragLayer";
import WireLayer from "./components/WireLayer/WireLayer";

import {
  //positionFromGridCoords,
  //dimensionFromGridDimensions,
  coordFromGridCoord
} from "../../helpers/grid";
import {
  //widgetGridDimensionsForWidgetTypes,
  GRID_SIZE,
  //BASEURL,
  widgetConsumesHistoData
} from "../../helpers/constants";

import {
  PRESENTATION_MODE,
  //PRESENTATION_MODE_DEFAULT,
  //PRESENTATION_MODE_FIT_H,
  //PRESENTATION_MODE_FIT_V,
  //PRESENTATION_MODE_STACK_H,
  //PRESENTATION_MODE_STACK_V
} from "../../helpers/constants";

import {
  //socketTransciever,
  disconnectSocket
} from "../../api/socketTransciever";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Widgets
import {
  SimpleNumerical,
  RadialGauge,
  LinearGauge,
  LineChart,
  ImageView
} from "./components/Widgets";


const CONTAINER_OUTER_PADDING = 10;
// This context provides useful layout vars to any children. Used for containerScale currently, where it is consumed in widgetHOC and propagated as a prop to the widgets.
export const LayoutContext = React.createContext({containerScale:1});
class DashboardComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { widgets_container_outer_el_bbox: undefined };
  }

  componentDidMount() {
    let self = this;
    console.log("Dashboard did mount", this.props);
    let { 
      //widgetConfig, 
      fetchDevices, 
      //dispatch 
    } = this.props;

    fetchDevices(this.fetchHistoData.bind(this));
    

    // Track size of widgets_container-outer for presentation view modes (scaling)
    self.widgets_container_outer_el = document.getElementById(
      "widgets_container-outer"
    );
    window.addEventListener(
      "resize",
      debounce(() => {
        console.log("resize");
        this.setState({ // use clientHeight because it respects the scrollbar, in contrast to getboundingclientrect
          widgets_container_outer_el_bbox: {width: this.widgets_container_outer_el.clientWidth, height: this.widgets_container_outer_el.clientHeight}
        });
      }, 100)
    );
  }

  componentWillReceiveProps(nextProps) {
    // console.log("componentWillReceiveProps", this);
    let self = this;
    // TODO: Find an alernative way instead of timer. Problem: BoundingRect is not yet changed, when uiMode transitions!
    window.setTimeout(() => {
      this.setState({
        widgets_container_outer_el_bbox: {width: self.widgets_container_outer_el.clientWidth, height: self.widgets_container_outer_el.clientHeight}
      });
    }, 0);
  }

  fetchHistoData() {
    let { requestSensorHisto, widgetConfig } = this.props;
    // Traverse widgetConfig, check if widget consumes histo data, if so, add sensor of device connected to widget to set (TODO: support parameters for histo fetch),
    // fetch histo data for every sensor of device in set
    let histoSensors = [];
    let lastValues = 100;

    Object.keys(widgetConfig).forEach(widgetid => {
      let widget = widgetConfig[widgetid];
      let consumesHistoData = widgetConsumesHistoData(widget.widget_type);


      // Traverse sensor_slots for devices
      consumesHistoData &&
        widget.sensor_slots.forEach(sensor_slot => {
          if (sensor_slot.deviceid && sensor_slot.sensorid) {
            requestSensorHisto(widgetid, sensor_slot.deviceid, sensor_slot.sensorid, undefined, undefined, undefined)
          }
        });
    });
    //  Get maximum of that lastValues per sensor and device!!
    // histoSensors form:
    // [
    // {deviceid: 4045, sensorid: 141, lastValues: 60},
    // {deviceid: 4045, sensorid: 141, lastValues: 150}, ...
    //]

    // TODO!!!!!!!
    /*     console.log("abc", histoSensors);
    let histoSensorMaxed = [];
    histoSensors.forEach(el => {
      if (histoSensorMaxed.some(el => {return (el.deviceid == histoSensorMaxed.deviceid && el.sensorid == histoSensorMaxed.sensorid)})) {
        console.log("abc-1");
      }

    }); */

    // Call fetch histo action for every element. Maybe use sth. like Promise.all in future..
    // for (const obj of histoSensors) {
    //   let { deviceid, sensorid } = obj;
    //   requestSensorHistoData(deviceid, sensorid, undefined, undefined, 5000); // 200 is temp!! real implementation throug max!
    // }
  }

  componentWillUnmount() {
    disconnectSocket();
  }

  widgetComponentForType(type) {
    switch (type) {
      case "alphanumeric":
        return SimpleNumerical;

      case "radialgauge":
        return RadialGauge;

      case "lineargauge":
        return LinearGauge;

      case "linechart":
        return LineChart;

      case "imageview":
        return ImageView;

      default:
        return SimpleNumerical;
    }
  }

  renderWidgetsGrid() {
    //console.log("renderWidgetsGrid");
    let { widgetConfig, uiConfig } = this.props;

    let WidgetComponents = Object.keys(widgetConfig).map(widget_key => {
      let widget = widgetConfig[widget_key];
      let { widget_type } = widget;
      let WidgetComponent = this.widgetComponentForType(widget_type);
      let {
        gridCoords = { gridx1: 0, gridy1: 0, gridx2: 0, gridy2: 0 }
      } = widget;

      let widgetCoords = {
        x1: coordFromGridCoord(gridCoords.gridx1, GRID_SIZE),
        y1: coordFromGridCoord(gridCoords.gridy1, GRID_SIZE),
        x2: coordFromGridCoord(gridCoords.gridx2, GRID_SIZE),
        y2: coordFromGridCoord(gridCoords.gridy2, GRID_SIZE)
      };

      return (
        <WidgetComponent
          key={widget_key}
          widgetid={widget_key}
          coords={widgetCoords}
        />
      );
    });

    // Traverse all widget elements to find the extremal x,y positions. Based on that, size the _widgets_container.
    let widgetDimensions = WidgetComponents.map(element => {
      return element.props.coords;
    });
    let widgetDimensionsMaxX2 = 0,
      widgetDimensionsMaxY2 = 0;
    widgetDimensions.forEach(dimObj => {
      if (dimObj.x2 > widgetDimensionsMaxX2) {
        widgetDimensionsMaxX2 = dimObj.x2;
      }
      if (dimObj.y2 > widgetDimensionsMaxY2) {
        widgetDimensionsMaxY2 = dimObj.y2;
      }
    });
    let widget_container_size = {
      width: widgetDimensionsMaxX2 +1,
      height: widgetDimensionsMaxY2 +1
    };

    // TODO: Handle Fit h and Fit v cases
    let { widgets_container_outer_el_bbox } = this.state;
    //console.log("uiConfig", uiConfig);
    let { presentationMode, uiMode } = uiConfig;
    let widget_container_scale = "";
    let _sc = 1;
    let widget_container_outer_style = {};
    if (!uiMode && widgets_container_outer_el_bbox) {
      if (presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_FIT_H) {
        // Calculate container scale
        // 40 is margin of widgets_container-outer. TODO: fetch value dyn.
        _sc =
          (widgets_container_outer_el_bbox.width - CONTAINER_OUTER_PADDING) /
          widget_container_size.width;
        _sc = Math.floor(_sc * 1000) / 1000;
        widget_container_scale = { transform: `scale(${_sc})` }; // Scale style. TODO: Make browser safe. No Auto-prefixes here!!

        widget_container_outer_style = {overflowX: "hidden"};
      } else if (
        presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_FIT_V
      ) {
        _sc =
          (widgets_container_outer_el_bbox.height - CONTAINER_OUTER_PADDING) /
          widget_container_size.height;
        _sc = Math.floor(_sc * 1000) / 1000;
        widget_container_scale = { transform: `scale(${_sc})` }; // Scale style. TODO: Make browser safe. No Auto-prefixes here!!

        widget_container_outer_style = {overflowY: "hidden"};
      }
    }
    let widgetsContainerCssClass = "widgets_container";
    widgetsContainerCssClass += (uiConfig.uiMode) ? "" : " nogrid";


    // Make container outer overflow hidden, because the browsers layout logic doesnt respect transforms, when calculating scroll areas.
    console.log("render dashboard container")
    return (
      <div id="widgets_container-outer" style={{...widget_container_outer_style }}>
        <div
          id="_widgets_container"
          className={widgetsContainerCssClass}
          style={{ ...widget_container_size, ...widget_container_scale }}
        >
          <LayoutContext.Provider value={{containerScale:_sc}}>        
            {WidgetComponents}
          </LayoutContext.Provider>
        </div>
      </div>
    );
  }

  // Render the widgets as stack (vertical and horizontal).
  // Vertical for now. TODO: horizontal
  // Vertical stack means, that all widgets are as wide as the viewport (overriding their coords), but get the height from their coords.

  // Traverse from left to right, from top to bottom to conserve the order of the grid.
  renderWidgetsStack(presentationMode) {
    let { widgetConfig, uiConfig } = this.props;
    let { widgets_container_outer_el_bbox } = this.state;
    // Sort the widget keys by x,y grid coords
    let sortedWidgetKeys = Object.keys(widgetConfig).sort(
      (widgetConfigKeyA, widgetConfigKeyB) => {
        if (
          !widgetConfigKeyA ||
          !widgetConfig[widgetConfigKeyA] ||
          !widgetConfig[widgetConfigKeyA].gridCoords ||
          !widgetConfigKeyB ||
          !widgetConfig[widgetConfigKeyB] ||
          !widgetConfig[widgetConfigKeyB].gridCoords
        ) {
          console.error("sortedWidgetKeys not sorting, because of an error.");
          return 1;
        }

        let rv = 0;
        let gridCoordsA = widgetConfig[widgetConfigKeyA].gridCoords,
          gridCoordsB = widgetConfig[widgetConfigKeyB].gridCoords;
        // TODO: add code for hor
        // Vertical
        //console.log("gridCoordsA", widgetConfigKeyA,  gridCoordsA, "gridCoordsB", gridCoordsB);

        if (gridCoordsA.gridx1 < gridCoordsB.gridx1) {
          rv = -1;
        } else if (gridCoordsA.gridx1 === gridCoordsB.gridx1){
          rv = 0;
        } else {
          rv = 1;
        }
        return rv;
      }
    );



    // Display the sorted widgets
    // for stack vertical: place widgets in a column, with the width as full width and the height as gridy2-gridy1
    // for stack horizontal: place widgets in a row, with the height as full height and the width as gridx2-gridx1
    let lastGridVar = -3; // Used for x or y respecively
    let WidgetComponents = sortedWidgetKeys.map(widget_key => {
      let widget = widgetConfig[widget_key];
      let { widget_type } = widget;
      let WidgetComponent = this.widgetComponentForType(widget_type);
      let {
        gridCoords = { gridx1: 0, gridy1: 0, gridx2: 0, gridy2: 0 }
      } = widget;

      let deltaGridVar, widgetCoords;
      if (presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_STACK_V) {
        deltaGridVar =
          coordFromGridCoord(gridCoords.gridy2, GRID_SIZE) -
          coordFromGridCoord(gridCoords.gridy1, GRID_SIZE);
        widgetCoords = {
          x1: 0,
          y1: lastGridVar,
          x2: widgets_container_outer_el_bbox
            ? widgets_container_outer_el_bbox.width - CONTAINER_OUTER_PADDING
            : 0,
          y2: lastGridVar + deltaGridVar
        };
      } else if (
        presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_STACK_H
      ) {
        deltaGridVar =
          coordFromGridCoord(gridCoords.gridx2, GRID_SIZE) -
          coordFromGridCoord(gridCoords.gridx1, GRID_SIZE);
        widgetCoords = {
          x1: lastGridVar,
          y1: 0,
          x2: lastGridVar + deltaGridVar,
          y2: widgets_container_outer_el_bbox
            ? widgets_container_outer_el_bbox.height - CONTAINER_OUTER_PADDING
            : 0
        };
      }

      lastGridVar = lastGridVar + deltaGridVar;
      //console.log("widgetCoords",widgetCoords)

      return (
        <WidgetComponent
          key={widget_key}
          widgetid={widget_key}
          coords={widgetCoords}
        />
      );
    });
    let widgetsContainerCssClass = "widgets_container";
    widgetsContainerCssClass += uiConfig.uiMode ? "" : " nogrid";
    return (
      <div id="widgets_container-outer">
        <div
          id="_widgets_container"
          className={widgetsContainerCssClass}
          //style={{ ...widget_container_size, ...widget_container_scale }}
        >
          {WidgetComponents}
        </div>
      </div>
    );
  }

  render() {
    let {
      devices,
      ui,
      uiConfig,
      requestAddDevice,
      toggleDeviceSettings,
      startDrag,
      setHoveredSensor,
      isWidgetDrag // This is used to change overflow behavior
    } = this.props;
    let { presentationMode, uiMode } = uiConfig;



    let maincontentCssClass = "dashboard-maincontent ";
    maincontentCssClass += uiMode ? "editor " : "";
    maincontentCssClass += isWidgetDrag ? "widgetDrag " : "";
    return (
      <div className="dashboard">
        <DragLayer />
        {uiMode && <WireLayer />}
        <Modal />
        <NavBar />
        <div className="dashboard-topbar">
          {uiMode ? (
            <div className="dashboard-topbar_content">
              <DeviceBar
                devices={devices}
                addDevice={requestAddDevice}
                toggleDeviceSettings={toggleDeviceSettings}
                startDrag={startDrag}
                drag={ui.drag}
                setHoveredSensor={setHoveredSensor}
                hoveredSensor={ui.hoveredSensor}
              />
            </div>
          ) : null}
        </div>
        <div className="dashboard-bottom">
          <div className="dashboard-leftbar">
            {uiMode ? <WidgetBar /> : null}
          </div>
          <div id="_dashboard-maincontent" className={maincontentCssClass}>
      
            {!uiMode &&
            (presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_STACK_H ||
              presentationMode === PRESENTATION_MODE.PRESENTATION_MODE_STACK_V)
              ? this.renderWidgetsStack(presentationMode)
              : this.renderWidgetsGrid()}
          </div>
        </div>
        <ToastContainer
          autoClose={1500}
          position="bottom-right"
          //hideProgressBar
        />
      </div>
    );
  }
}

export default DashboardComponent;

// TODO: outsource

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
